export default __webpack_public_path__ + "static/media/illustration-2-eng.17bb1b29.svg";